
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-designer",
      function () {
        return require("private-next-pages/product-designer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-designer"])
      });
    }
  